import tabsToggle from "../modules/tabsToggle";
import CategoryFilter from "../modules/categoryFilter";

const checkHeight = elem => {
    let maxHeight = 0;
    elem.forEach(el => {
        const mainHeight = el.clientHeight;
        maxHeight = maxHeight < mainHeight ? mainHeight : maxHeight;
    });

    return maxHeight;
};

function setHeights(smartGrid) {
    const descriptions = smartGrid.querySelectorAll(".smartGridItem__description");
    const subtitles = smartGrid.querySelectorAll(".smartGridItem__subtitle");
    const resourceAreas = smartGrid.querySelectorAll(".smartGridItem__resources");
    const btnContainers = smartGrid.querySelectorAll(".smartGridItem__btnContainer");

    descriptions.forEach(el => {
        const setHeight = checkHeight(descriptions);
        el.style.height = `${setHeight}px`;
    });

    subtitles.forEach(el => {
        const setHeight = checkHeight(subtitles);
        el.style.height = `${setHeight}px`;
    });

    resourceAreas.forEach(el => {
        const setHeight = checkHeight(resourceAreas);
        el.style.height = `${setHeight}px`;
    });

    btnContainers.forEach(el => {
        const setHeight = checkHeight(btnContainers);
        el.style.height = `${setHeight}px`;
    });
}

function init() {
    var smartGrids = document.querySelectorAll(".smartGrid");
    if (smartGrids.length > 0) {
        for (let i = 0; i < smartGrids.length; i++) {
            let smartGrid = smartGrids[i];
            setHeights(smartGrid);
            tabsToggle.init(smartGrid);

            new CategoryFilter(smartGrid);
        }
    }
}

export default { init };
